export default "__VITE_ASSET__CYweFB6B__"